<template>
	<div class="modalContainer">
		<div class="modalOpenTarget" @click="openModal">
			<!-- slot for content that when clicked will open the modal -->
			<slot name="modalOpenContent">Open</slot>
		</div>
		<transition name="modal-fade">
			<ModalContent @close="closeModal" v-if="modalOpen">
				<!-- Slot for header content to fill the modal -->
				<template  #modalHeaderContent>
					<slot name="modalHeaderContent">
						No Content
					</slot>
				</template>
				<template #modalContent>
					<slot name="modalContent" >
						No Content
					</slot>
				</template>
				<template #modalFooterContent>
				<slot name="modalFooterContent" >
						No Content
					</slot>
				</template>
			</ModalContent>
		</transition>
	</div>
</template>

<script>
import ModalContent from "./Modal_Content";

export default {
	name: "ModalContainerContent",
	components: {
		ModalContent
	},
	data() {
		return {
			modalOpen: false
		};
	},
	methods: {
		closeModal() {
			this.modalOpen = false;
			document.querySelector("body").classList.remove("noscroll")
		},
		openModal() {
			this.modalOpen = true;
			document.querySelector("body").classList.add("noscroll")
		}
	}
};
</script>

<style lang="scss" scoped>
.modal-fade-leave-active {
  transition: all 0.3s ease;
}

.modal-fade-enter-active {
  transition: all 0.5s ease;
  //   transition-delay: 0.3s;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modalOpenTarget{
    cursor:pointer;
}
// .modal-fade{
//     transition: all 1s;
// }
// .modal-fade-enter, .modal-fade-leave-to{
//     transform: scale(0)
// }

// .modal-fade-leave-active, .modal-fade-enter-active {
//   transition: all 200ms ease-in;
// //   position: absolute;
// //   z-index: 0;
// }
</style>
